(function () {

  'use strict';

  angular.module('Sites')

    .controller('SitesController', function (
      $scope, EventHandlerService, currentTenant, $window, localStorageService, $cookies,
      $timeout, SitesListPaging, $rootScope, enums, CopilotService) {

      let storageObject = null;
      let structureContainerWidth = 0;
      $scope.helpCaption = 'HelpSitesPage';
      $scope.resizing = false;
      $scope.currentTenant = currentTenant;
      $scope.sitesPaginationObject = new SitesListPaging();
      $scope.sitesPaginationObject.pagingCriteria.page = 0;
      $scope.sitesPaginationObject.pagingCriteria.pageSize = 20;
      $scope.sitesPaginationObject.pagingCriteria.type = 'SINGLE';
      $scope.me = null;
      $scope.enums = enums;

      (function () {
        initEventHandler();
        setDOMListeners();
        initStorage();
        fulfillCopilotRequest();
      })();

      function fulfillCopilotRequest() {
        const copilotActionElements = angular.element('[copilot-action]');
        if (!copilotActionElements) { return; }

        // Filter the buttons for the one with the value 'SITES'
        const copilotActionButton = Array
          .from(copilotActionElements)
          .find(button => button.getAttribute('copilot-action') === 'SITES');
        if (!copilotActionButton) { return; }
        const copilotAction = copilotActionButton.getAttribute('copilot-action');
        if (!copilotAction || CopilotService.state.requestedAction.responseType !== copilotAction) {
          return;
        }
        $timeout(function () {
          // Sometimes the rect returns 0,0, so we need to set a default value.
          const elementRect = copilotActionButton.getBoundingClientRect();
          const clientX = elementRect.x || 200;
          const clientY = elementRect.y + elementRect.width || 200;
          $scope.openRootCreatePopup({ clientX, clientY },
            'file', CopilotService.useSiteName());
        }, 100);
      }

      $scope.$watch(function () {
        return CopilotService.state.requestedAction;
      }, function () {
        fulfillCopilotRequest();
      });

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          initWidth();
        }
      });

      function initEventHandler() {
        EventHandlerService.deRegisterListeners();
      }

      $scope.openRootCreatePopup = function (event, type, itemName) {
        $timeout(function () {
          $scope.rootCreateData = {
            itemName: itemName || '',
            type,
            position: { left: event.clientX, top: event.clientY }
          };
        }, 100);
      };

      $scope.closeRootlevelCreatePopup = function () {
        $scope.rootCreateData = null;
      };

      // HANDLE RENDERING WIDTH OF DOM ELEMENTS
      function initStorage() {
        if (localStorageService.isSupported) {
          storageObject = localStorageService;
        } else {
          storageObject = $cookies;
          storageObject.set = function (key, value) {
            return storageObject.put(key, value);
          };
        }
      }

      function initWidth() {
        structureContainerWidth = storageObject.get('sitesRelativeWidth');
        if (structureContainerWidth) {
          angular.element('.structure-toolbar').css({ width: structureContainerWidth });
          angular.element('.sites-tree-container').css({ width: structureContainerWidth });
          angular.element('.sites-container').css({ width: angular.element('.container')[0].clientWidth - (structureContainerWidth) - CopilotService.state.copilotWidth });
        } else {
          angular.element('.sites-container').css({ width: angular.element('.container')[0].clientWidth - (angular.element('.sites-tree-container')[0].clientWidth + 55) - CopilotService.state.copilotWidth });
        }
      }

      function setDOMListeners() {
        angular.element($window).on('resize', function () {
          initWidth();
        });
      }

      $scope.$on('$destroy', function () {
        angular.element($window).off('resize');
      });

      $scope.showTooltip = function (showTip, position, tooltipScope) {
        // && !scope.resizing && !scope.dragging
        if (showTip) {
          switch (tooltipScope) {
            case 'folder':
              folderTooltip(position);
              break;
            case 'file':
              siteTooltip(position);
              break;
          }
        } else {
          $scope.clearTooltip();
        }
      };

      function siteTooltip(position) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          type: 'statement',
          title: 'CreateSite'
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function folderTooltip(position) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          type: 'statement',
          title: 'NewFolder'
        };
        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      $scope.clearTooltip = function () {
        $scope.tooltipContent = null;
        $scope.tooltipObject = null;
      };

    });
})();
